import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import * as Constants from '../../../models/Constants';
import {
  AlertMsg,
  errorObj,
  iconConfig,
  REGEX,
} from 'src/app/models/Constants';
import { CustBusService } from 'src/app/services/customer-search-bussiness-logic.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { AlightTableComponent } from '../../common/alight-table/alight-table.component';
import { columnsModel } from 'src/app/models/customer.model';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';
import { CustomerAccountBusinessLogicService } from 'src/app/services/customer-account-business-logic.service';
import { ApiService } from 'src/app/services/api.service';
import { Subscription } from 'rxjs';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';

declare var $: any;
const moment = _rollupMoment || _moment;
// added code to format date in text box- e.g - May-30-2023
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'MMM-DD-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'll',
    monthYearA11yLabel: 'MMM YYYY',
  },
};


@Component({
  selector: 'app-customer-search-unidentified-call',
  templateUrl: './customer-search-unidentified-call.component.html',
  styleUrls: ['./customer-search-unidentified-call.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class CustomerSearchUnidentifiedCallComponent implements OnInit {
  iconConfig: object = iconConfig.bullHorn;

  alertConfig: object = errorObj;
  selectedRow;
  @ViewChild(AlightTableComponent) alightTable;

  inboundMsg: string = Constants.INBOUND_CALL_ACCESS_ERRORMSG;

  AdditionalAccountChatMsg: string = Constants.Additional_Account_Chat_Msg;

  errorMsg = AlertMsg;

  customerSearchForm: FormGroup = new FormGroup({});

  public Columns: columnsModel[] = [
    { field: 'lastName', header: 'Last Name', width: 24 },
    { field: 'firstName', header: 'First Name', width: 24 },
    { field: 'address', header: 'Address', width: 40 },
    { field: 'dateOfBirth', header: 'Date of Birth', width: 10 },
    { field: 'nationalId', header: 'National ID', width: 10 },
    { field: 'employeeId', header: 'Emp ID', width: 10 },
    { field: 'postalCode', header: 'Postal Code', width: 10 },
  ];

  public dataSource: any = new MatTableDataSource();

  public clients: Array<any> = new Array<any>();

  public customers: Array<any> = new Array<any>();

  accountModal: any = 'additional';

  isModalOpen: boolean = false;

  public totalCount: string = Constants.DefaultTableRange;

  totalRecords!: number;

  isTotalCountMore: boolean = false;

  invalid = false;

  selectedValue: any;

  render: boolean = false;

  loaderType = Constants.LOADER_TYPE.CARD;
  unidendifiedCallTitle: string = '';
  isAccountOpen: boolean = false;
  clientId: any;
  public userSubscription!: Subscription;
  public maxDate = new Date();

  constructor(
    private fb: FormBuilder,
    public rootService: RootScopeService,
    public customerService: CustBusService,
    private eRef: ElementRef,
    public genesysCloudService: GenesysCloudService,
    private router: Router,
    public cusAccService: CustomerAccountBusinessLogicService,
    public apiService: ApiService,
    public route: ActivatedRoute
  ) {
    this.customerService.accessComponent(this);

    this.createForm();


  }

  ngOnInit(): void {

    this.userSubscription = this.route.params.subscribe((params: any) => { //CCR1-6606 Added subscription for recall ngOnInit for
    //  multiple duplicate customer search page


    this.rootService.activeCustTab = this.rootService.getObjFromArray(
      this.rootService.customerTabs,
      'customerSessionId',
      this.rootService.customerLink
    );
    this.rootService.customerTypeDrpDwn = 'ACH';
    this.customers = this.rootService.customerTypeData;
    this.dataRetain();
    this.liveCallFn();
    this.rootService.isDuplicateCustSearchTabOpened = true;
    // this.pageTitle();
    this.checkDomainData();
    this.cusAccService.defaultServiceOnLoad();
    this.updateGenesysParticipantAttributesClienttID(); //CCR1-9880
   });
  }

/**
 * CCR1-9880
 * @author :Pooja 
 * Updating Genesys participant attributes with clientId for invalid clientId in queuname
 * in transfer scenario case
 */

  updateGenesysParticipantAttributesClienttID() {
    let body = {
      attributes: {
        CS_CLIENT_ID: this.rootService.activeCustTab?.clientId,
      }
    }
    let conversationId = this.rootService.activeCustTab?.conversationId, participantId = this.rootService.activeCustTab?.customerParticipantId;
    if (this.rootService.activeCustTab?.activeCall) {
      conversationId = this.rootService.genesysCallObj?.eventBody?.id;
      let liveCustomer = this.rootService.genesysCallObj?.eventBody?.participants.find(
        (x) =>
          x?.['purpose'] == 'customer' &&
          x?.['state'] == 'connected'
      );
      participantId = liveCustomer?.id || this.rootService.activeCustTab?.customerParticipantId;//CCR5-774

    }
    this.genesysCloudService.updateParticipantAttributes(conversationId, participantId, body);
    
  }


  customerUnidentifiedPopup() {
    this.rootService.openDialog({
      title: '',
      subheading: '',
      message: "The customer selected does not match with customer identified in ALIS. Search again, or if unable to find the correct customer, select the Unknown Caller button.",
      firstbutton: '',
      secondbutton: 'Got it',
      crossIcon: false,
      comingFrom: 'main',
      additionalClass: 'alis-modal',
    });
  }

  /**@author vamsikrishna 
   * to dataRetain for swiching the tabs
  */
  dataRetain() {


    if (this.rootService.unknownTab && this.rootService.isLiveCall) {
      this.customerSearchForm.patchValue(this.rootService.unknownTab.customerSearchForm.value);
      if (this.rootService.unknownTab.dataSource?.filteredData?.length > 0) {
        this.dataSource = new MatTableDataSource(this.rootService.unknownTab.dataSource?.filteredData);
        this.customerService.setTableData(this, this.rootService.unknownTab.dataSource?.filteredData?.length);
      } else this.rootService.scrollToTop();
    }
  }

  pageTitle() {
    //unidendifiedCallTitle: string = '';
    let unidendifiedCallTitle = '';
    let tab = _.find(this.rootService.customerTabs, (each) => each.id == 1 && each.customerSessionId == this.rootService.customerLink);

    if (tab?.title == Constants.unidentifiedCalls.Callback)
      unidendifiedCallTitle = Constants.unidentifiedCalls.CallbackfromQueue;
    else if (tab?.title == Constants.unidentifiedCalls.Outbound)
      unidendifiedCallTitle = Constants.unidentifiedCalls.Outbound;
    else if (tab?.title == Constants.unidentifiedCalls.UnknownCaller && tab?.channel == Constants.conversion.chat)
      unidendifiedCallTitle = Constants.unidentifiedCalls.InboundChat;
    //to handle alternative outbound call 
    else
      unidendifiedCallTitle = Constants.unidentifiedCalls.InboundCall;

    return unidendifiedCallTitle;
    //  return this.rootService.isLiveCall ? unidendifiedCallTitle : unidendifiedCallTitle + ' (inactive)';
  }

  createForm() {
    // console.log('createForm ', this.rootService.customerSearchForm);
    this.getClientInfoCardData({})
    this.createCustomerSearchForm({});
  }

  getClientInfoCardData(data) {
    this.clientId = this.getClientId(data);
    this.cusAccService.getClientInfoCardData(this.clientId, false, this);
    this.cusAccService.getClientInfoCardDefaultService(this.clientId);

  }

  getClientId(data) {
   
    if (data['clientId']) {
      return data['clientId'] + '';
    } else if (this.customerService.Gensysvalidation(this)) {
      if (!data['customerType']) {
        data['customerType'] = 'ACH';
      }
      /**LIVE Mode ON */
      if (this.rootService.isLiveCall) {
        return this.customerService.liveClient;
      } else return this.customerService.liveChat[Constants.ALS_chat.ClientID];
    } else return null;
  }

  createCustomerSearchForm(data) {
    // console.log('Method createCustomerSearchForm called', data);
                /**Comment for CCR1-2695 */
    // let dateOfBirth = this.rootService.dateFormatter(
    //   data['dateOfBirth'],
    //   'MM/dd/YYYY'
    // );

    this.customerSearchForm = this.fb.group({
      clientId: new FormControl(this.getClientId(data), Validators.required),
      customerType: new FormControl(data['customerType']),
      lastName: new FormControl(data['lastName'], [
        Validators.required,
        Validators.pattern(REGEX.character),
      ]),
      firstName: new FormControl(data['firstName']),
      // dateOfBirth: new FormControl(dateOfBirth, [
      //   Validators.pattern(REGEX.date),
      // ]),
      dateOfBirth: new FormControl<Date | null>(data['dateOfBirth']),
      nationalId: new FormControl(data['nationalId'], [
        Validators.minLength(4),
        Validators.pattern(REGEX.nospace),
      ]),
      employeeId: new FormControl(data['employeeId']),
      postalCode: new FormControl(data['postalCode']),
    });
  }

  public submit() {   

    if (this.invalidForm()) return;
    else {
    
      setTimeout(() => {
        $('#txtSearch')[0].focus();
      }, 100);

      this.customerService.getSearchData(this.customerSearchForm.value, this);
    }
  }

  /*Set Live call Details and if live call details not avaible set default value */

  public liveCallFn() {
    
    if (this.customerService.Gensysvalidation(this)) {
  
      this.customerSearchForm.get('customerType')?.setValue('ACH');
      if (!this.rootService.checkForUnsecuredChat()) {

        this.customerSearchForm.get('clientName')?.disable();
        this.customerSearchForm
          .get('clientId')
          ?.setValue(this.customerService.setUnknownTabClient());
      }

      else if (this.rootService.isLiveCall) {
        this.customerSearchForm
          .get('clientId')
          ?.setValue(this.customerService.liveClient);
      }
    }
  }

  /*Clear all Based on live call and off call*/

  public clearAll() {
    /* Curent form ignore errors */
    if (!this.rootService.isLiveCall)
      this.onClientChange('CLEAR');


    $('#txtCustomerForm')?.[0]?.reset();
    this.totalCount = Constants.DefaultTableRange;
    this.liveCallFn();
    this.invalid = false;
    this.totalRecords = -1;
    this.rootService.scrollToTop();
    this.rootService.customerSearchForm = new FormGroup({});
    this.resetTableData();
  }

  resetTableData() {
    this.alightTable?.clearAll();
    this.dataSource = new MatTableDataSource([]);
  }
  /*end Clear all fn */

  /*Validation Functions  */

  public errorHandling = (control: string, error: string) => {
    return this.customerSearchForm.value.clientId
      ? this.customerSearchForm.controls[control].hasError(error)
      : false;
  };

  public onKeyUp(event, option) {
    
    switch (option) {
      case 'dateOfBirth':
        let DobVal = event.target?.value;
        this.customerSearchForm.controls[option].markAsTouched();
        if (
          event.keyCode >= 48 &&
          event.keyCode <= 57 &&
          (DobVal?.length === 2 || DobVal?.length === 5)
        ) {
          this.customerSearchForm.controls['dateOfBirth'].setValue(
            DobVal + '/'
          );
        }
        break;

      default:
        if (event.target.value)
          this.customerSearchForm.controls[option].markAsTouched();
        break;
    }
  }
  /*Before form submit Check all validations  */

  public invalidForm() {
    let invalidForm = this.customerSearchForm.controls;
    this.invalid = false;
    
    for (let id in invalidForm) {      
      
      if (invalidForm[id].invalid) {
        this.invalid = true;        
        return this.invalid;
      }
    }
    return this.invalid;
  }

  /*Client Validation Base Focus */

  onFocus(event) {
    if (
      this.customerSearchForm.value.clientId == 0 ||
      !this.customerSearchForm.value.clientId
    ) {
      $('#Client')[0]?.focus();

      if (this.customerSearchForm.get('lastName')?.invalid) {
        this.customerSearchForm.get('lastName')?.markAsPristine();
        this.customerSearchForm.get('lastName')?.markAsUntouched();
      }
    }
  }

  showUnknowncallerTab() {
    this.rootService.activeCustTab.wrapUpData.unknownCallerWrapupPage = true;
    this.rootService.unknownTab = this;
  }



  
  rowSelection(data) {

   
    let identifiedCall: boolean = false;

    if (this.rootService.isLiveCall && this.customerService.liveCall?.UDP_GBL_ID) {
      if (this.customerService.liveCall?.UDP_GBL_ID != data?.row?.udpId) {
        this.rootService.activeCustTab.tabData = null;
        this.customerService.liveCall[Constants.ALIS_ATTRIBUTE_NAMES.CIM_DATA]="";
        this.customerService.liveCall['PINV'] = Constants.PINV_ATTRIBUTES.IDENTIFIED_UNSECURED;
      } else {
        identifiedCall = true;
        this.rootService.activeCustTab.tabData['identifiedCall'] = true;
      }


    }
    /**below piece of line added in order not allow CSR to open customer accunt from this tab
      * when call gets disconnected */
    /*Commented below code as it was allowing to open customer tab for an offline SL1 call 
     when another SL1 live call is avalible in background */
    /* if (!this.rootService.isLiveCall) {
       return;
     }*/

    if (!this.rootService.displayRedIcon) {
      return;
    }

    this.customerService.openAdditonalAcc = null;
    this.selectedRow = data?.row;
    data.row.customerType = this.rootService.isLiveCall && data.buttonName != Constants.buttonEnum.additionalAccount ? (this.customerSearchForm?.value?.customerType || 'ACH') : 'ACH';
    data.row.clientId = this.customerSearchForm?.value?.clientId;

    if (data.buttonName == Constants.buttonEnum.customerAccount) {
      this.rootService.callFromSL1Tab = true; this.customerService.parentData = null;



      let that = this;

      if (this.rootService.isLiveCall && this.rootService.activeCustTab?.tabData && !identifiedCall) {
        
        that.genesysCloudService.updateSL1CallAttributes(data, this.customerSearchForm?.value?.customerType);
      }
      else if (this.rootService.isLiveChat) {
        this.rootService.patchGENAttribute.next({
          conversationId: this.rootService?.activeCustTab?.conversationId,
          participantId: this.rootService?.activeCustTab?.customerParticipantId,
          body: {
            attributes: {
              'context.glblPrsnId': data?.row?.udpId,
              PINV: Constants.PINV_ATTRIBUTES.FULLY_SECURED
            }
          }
        })
      }
      this.customerService.getPersonData(data, this.rootService.activeCustTab.tabData?.["genesysRes"]);
      

      this.rootService.custSearchLoader = true; this.isAccountOpen = true;

    }
  }



  activeChatCustomers: any[] = [];

  // multiChatCustPopup() {
  //   this.activeChatCustomers = this.rootService.customerTabs.filter(
  //     (x) =>
  //       !x.additionalAccount &&
  //       x.activeChat &&
  //       x.tabData.tabData.clientId == this.customerSearchForm.value.clientId
  //   );

  //   if (this.activeChatCustomers?.length > 1) {
  //     this.accountModal = 'chat';
  //     this.isModalOpen = true;
  //     this.rootService.scrollToTop();
  //   } else this.findCustomer(this.activeChatCustomers[0]?.id);
  // }

  closeAdditonalAcc() {
    this.customerService.mustCloseAddionalPopup();
    this.rootService.scrollToTop();
  }

  reasonForAdditionalPopUp() {
    this.accountModal = 'additional';
    this.isModalOpen = true;
    this.rootService.scrollToTop();
  }

  // buttonClick(data) {
  //   let type = data['type'];
  //   let buttonType = data['buttonType'];
  //   if (
  //     type == Constants.CLOSE_ADD_ACNT_BUTTON &&
  //     buttonType == Constants.CLOSE_ADD_ACNT_BUTTON
  //   ) {
  //     this.customerService.closeAddAccount();
  //     if (data?.msg == Constants.Additional_Account_Chat_Msg)
  //       this.reasonForAdditionalPopUp();
  //   }
  // }

  // buttonEvent(event) {
  //   switch (event.btnName) {
  //     case Constants.buttonEnum.continue:
  //       this.isModalOpen = false;

  //       if (this.accountModal == 'chat') {
  //         this.findCustomer(event.customer);
  //         // this.customerService.openAdditonalAcc =
  //         //   this.rootService.customerTabs.find(
  //         //     (x) => x.id == event.customer
  //         //   )?.additionalAccountId;
  //         // this.customerService.openAdditonalAcc
  //         //   ? this.closeAdditonalAcc()
  //         //   : this.reasonForAdditionalPopUp();
  //       } else {
  //         // this.customerService.parentId = this.customerService.parentId
  //         //   ? this.customerService.parentId
  //         //   : this.rootService.customerTabs.find(
  //         //     (x) => (x.activeCall || x.activeChat) && !x.additionalAccount
  //         //   )?.id;

  //         // this.customerService.getParentData(this.customerService.parentId);
  //         // this.customerService.reasonForAdditional = {
  //         //   firstReason: event.primaryValue.label,
  //         //   secondReason: event.secondaryValue.label,
  //         // };
  //         this.customerService.getPersonData({
  //           row: this.selectedRow,
  //           buttonName: Constants.buttonEnum.additionalAccount,
  //         });
  //         this.rootService.custSearchLoader = true;
  //         // console.log('conv', this.rootService.conversationId);
  //       }
  //       break;

  //     case Constants.buttonEnum.cancel:
  //       this.isModalOpen = false;
  //       break;
  //   }
  // }

  // findCustomer(custId) {
  //   // this.customerService.parentId = custId;
  //   this.customerService.getParentData(custId);
  //   this.customerService.openAdditonalAcc = this.rootService.customerTabs.find(
  //     (x) => x.id == custId
  //   )?.additionalAccountId;
  //   this.customerService.openAdditonalAcc
  //     ? this.closeAdditonalAcc()
  //     : this.reasonForAdditionalPopUp();
  // }

  onClientDropDownChange(data) {
    // console.log('Method onClientDropDownChange called ', data);
    this.resetFormOnClientChange(data);
    this.resetTableData();
  }


  onClientChange(event) {
    console.log("event", event)
    if (event == 'CLEAR') {
      /** handling click of clear All  */
      this.clientId = 'NA';
      this.rootService.clientInfoCard.clientInfoVSClientIdMap[this.clientId] = [];
    }


    if (event.value) {
      this.rootService.activeCustTab.clientId = event.value;
      this.cusAccService.getClientInfoCardData(event.value, false, this);
      this.cusAccService.getClientInfoCardDefaultService(event.value);
    }

  }

  resetFormOnClientChange(data) {
    this.createCustomerSearchForm({ clientId: data['value'] });
  }

  /**Below method checks if the outbound call dialing is allowed based on certain conditions.
   * Returns: True if outbound call dialing is allowed, otherwise false.*/
  checkDialing() {
    let tab = _.find(this.rootService.customerTabs, (each) => each.id == 1 && each.customerSessionId == this.rootService.customerLink);
    if (tab?.outboundCallDialing && this.rootService.displayRedIcon) {
      return true;
    }
    return false
  }

  checkDomainData() {
    if (!this.rootService.wrapupTopicDataMap[this.rootService.activeCustTab.clientId])
      this.getDomainList();
  }

  /** 
   * getDomainList -- calling API to get getDomainList.
   * @author :Amarjeet Kumar
   */
  getDomainList() {
    this.apiService.getDomainList().subscribe({
      next: (data: any) => {
        this.rootService.wrapupTopicDataMap[this.rootService.activeCustTab.clientId] = data.data;
      },
      error: (error) => {
        this.rootService.domainListAPIFailure = true;
        console.log(error);
      },
    })
  }


  /**@author sultan 
  * to dataRetain for swiching the Unknown Caller page
 */
  dataRetainFromUnknownCaller() {

    if (this.rootService.unknownTab) {
      this.customerSearchForm.patchValue(this.rootService.unknownTab.customerSearchForm.value);
      if (this.rootService.unknownTab.dataSource?.filteredData?.length > 0) {
        this.dataSource = new MatTableDataSource(this.rootService.unknownTab.dataSource?.filteredData);
        this.customerService.setTableData(this, this.rootService.unknownTab.dataSource?.filteredData?.length);
      } else this.rootService.scrollToTop();
    }
  }


  ngOnDestroy() {
    if (this.rootService.isLiveCall && !this.isAccountOpen) this.rootService.unknownTab = this;
    else this.rootService.unknownTab = null;
  }
}
